<template>
  <div style="padding-bottom: 6rem;">
    <header>
      <h1>NOVA INTEGRAÇÃO</h1>
    </header>
    <section class="suporte">
      <div class="contaner">
        <div class="row">
          <div class="col-12 col-sm-12">
            <h1>FORMULÁRIO DE INTEGRAÇÃO</h1>
            <hr class="divider">
          </div>
          <div class="col-8 col-sm-8 offset-2">
            <!-- <p>Por favor, forneça os detalhes da sua dúvida ou solicitação preenchendo o formulário abaixo que em breve iremos atendê-lo.</p> -->
          </div>
          <form id="formSuporte" @submit.prevent="salvarFormulario()" novalidate>
            <!-- 1 -->
            <fieldset class="fieldset-border">
              <legend class="legend-border"><i class="fa-solid fa-code"></i>Catalogo API</legend>
              <div class="row">
                <div class="col-4 col-sm-4 col-md-4">
                  <select id="select-catalogo" class="form-select" ref="selectCatalogo" v-model="selectCatalogo"
                    @change="atualizarSelectApi(), checkInputs()"
                    oninvalid="this.setCustomValidity('Esse campo é obrigatório!')" oninput="this.setCustomValidity('')"
                    required>
                    <option value="" selected>Selecione o Catálogo</option>
                    <option value="Vendas">Vendas</option>
                    <option value="Gestão">Gestão de Carteira</option>
                    <option value="Pós-venda">Pós Venda</option>
                  </select>
                </div>
                <div class="col-4 col-sm-4 col-md-4">
                  <div class="form-outline">
                    <select id="select-api" class="form-select" ref="selectApi" @change="checkInputs()"
                      v-model="selectApi" :disabled="!selectCatalogo"
                      oninvalid="this.setCustomValidity('Esse campo é obrigatório!')"
                      oninput="this.setCustomValidity('')" required>
                      <option value="" selected>Seleciona a API</option>
                      <option v-for="e in apis" :key="e" :value="formatarValue(e)">{{ e }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-4 col-sm-4 col-md-4">
                  <div class="form-outline">
                    <input value-type="format" id="dateInput"
                      oninvalid="this.setCustomValidity('Esse campo é obrigatório!')"
                      oninput="this.setCustomValidity('')" lang="pt-br" class="form-control active" maxlength="10"
                      required type="text" />
                    <label class="form-label" for="">Término de Desenvolvimento:</label>
                    <FormNotch />
                  </div>
                </div>
              </div>
            </fieldset>

            <!-- 2 -->
            <fieldset class="fieldset-border" id="perguntaRepostaColuna" v-show="showPerguntas">
              <legend class="legend-border"><i class="fa-regular fa-message"></i>Pergunta/Resposta</legend>

              <div
                v-for="p in visiveis"
                :key="p.index"
              >
                <div class="col">

                  <div v-if="p.tipo === 'texto'" class="form-outline">
                    <label class="form-label">&nbsp;&nbsp;{{ p.pergunta }}</label>
                    <textarea
                      class="form-control"
                      rows="2"
                      placeholder=""
                      :id="slugify(p.pergunta)"
                      :value="p.resposta || ''"
                      @input="atualizarResposta(p.index, null, $event.target.value)"
                      oninvalid="this.setCustomValidity('Esse campo é obrigatório!')"
                      oninput="this.setCustomValidity('')"
                        :required="p.exibe === 'S'"
                      :disabled="p.exibe !== 'S'"
                    ></textarea>
                    <FormNotch />
                  </div>

                  <div v-else-if="p.tipo === 'radio'">
                    <label class="form-label d-block">&nbsp;{{ p.pergunta }}</label>
                    <div class="ps-2" style="margin-bottom: 22px !important;">
                      <div v-for="(opt,i) in p.opcoes" :key="i" class="mb-2" >
                        
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :id="`radio-${p.index}-${i}`"
                            :name="`radio-${p.index}`"
                            :value="opt"
                            :checked="p.resposta === opt"
                            @change="atualizarResposta(p.index, i+1, opt)"
                          >
                          <label class="form-check-label" :for="`radio-${p.index}-${i}`">{{ opt }}</label>
                          
                        </div>
                        
                      </div>
                      <hr >

                    </div>
                  </div>

                </div>
              </div>
            </fieldset>



            <!-- 3 -->
            <fieldset class="fieldset-border">
              <legend class="legend-border"><i class="fa-solid fa-clipboard-list"></i>Observação</legend>
              <div class="row">
                <div class="col">
                  <div class="form-outline">
                    <textarea class="form-control" rows="5" id="observacao" placeholder="" ref="observacao"></textarea>
                    <label class="form-label" for=""> </label>
                    <FormNotch />
                  </div>
                </div>
              </div>
            </fieldset>
            <div class="row">
              <div class="col d-flex justify-content-center">
                <button type="submit" class="btn btn-primary mt-1">ENVIAR SOLICITAÇÃO</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
    <div class="loader">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
import FormNotch from './FormNotch.vue';
import * as alertUtils from '@/utils/alert';
import * as ajaxUtils from '@/utils/ajax';

export default {
  components: {
    FormNotch
  },

  data() {
    return {
      apiReturnData: "",
      selectCatalogo: "",
      selectApi: "",
      apis: [],
      dados: {
        tipo: "",
        ambiente: "",
        catalogo: "",
        api: "",
        urlServico: "",
        detalhe: ""
      },
      arquivo: null,
      dadosFormulario: [],
      respostas: {},
      showPerguntas: false
      }
  },

  methods: {
    checkInputs() {
      const selectApi = $("#select-api").val();
      const selectCatalogo = $("#select-catalogo").val();

      const selectCatalogoParsed = selectCatalogo.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, '-');
      const selectApiParsed = selectApi.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, '-');
      const formularioId = selectCatalogoParsed + '-' + selectApiParsed;

      if (selectApi.length >= 1 && selectCatalogo.length >= 1) {
        $("#perguntaRepostaColuna").css("display", "block");

        this.consultarFormulario(formularioId);
      } else {
        $("#perguntaRepostaColuna").css("display", "none");
      }
    },
    async salvarFormulario() {
      const selectApi = $("#select-api").val();
      const selectCatalogo = $("#select-catalogo").val();
      const inputTerminoDesenvolvimento = $("#dateInput").val();

      let inputObservacao = $("#observacao").val();

      if (inputTerminoDesenvolvimento.length < 10) {
        alertUtils.alertError("Preencha o campo 'Término de Desenvolvimento' corretamente.");
        return false;
      }

      if (inputObservacao.length < 1) inputObservacao = "";

      let listaPerguntaReposta = [];
      let urlApi;
      let jsonRequest;

      this.dadosFormulario.forEach(item => {
        let resposta = $("#" + item.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-')).val();

        listaPerguntaReposta.push({ "pergunta": item, "resposta": resposta });
      });

      const bodyFormulario = {
        "catalogo": selectCatalogo,
        "api": selectApi,
        "dataTerminoDesenvolvimento": inputTerminoDesenvolvimento.replace(/\//g, "-"),
        "observacao": inputObservacao,
        "listaPerguntaResposta": listaPerguntaReposta
      }

      urlApi = '/massificados/corporativo/gerenciador-parceiros/integracao/salvar-integracao';

      jsonRequest = JSON.stringify(bodyFormulario);

      const salvarFormulario = await ajaxUtils.postOK(urlApi, jsonRequest, 'Salvo com sucesso!', '');

      if (salvarFormulario === true) {
        // 1. Quando o botão btn-primary for clicado
        document.querySelectorAll('.btn-primary').forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();  // Impede o comportamento padrão, caso necessário
            location.reload();  // Faz o reload da página
          });
        });

        // 2. Quando o usuário clicar fora do modal
        document.addEventListener('click', function (event) {
          // Verifica se o clique aconteceu fora do modal
          var modal = document.querySelector('.swal2-icon-success');
          if (modal && !modal.contains(event.target)) {
            location.reload();  // Faz o reload da página
          }
        });
      }
    },
    atualizarSelectApi() {
      this.selectApi = "";
      switch (this.selectCatalogo) {
        case "Vendas":
          this.apis = ['Automóvel', 'Residencial', 'Imobiliário', 'Condomínio', 'Vida', 'Aluguel', 'Garantia', 'Empresarial', 'Equipamentos', 'Viagem'];
          break;
        case "Gestão":
          this.apis = ['Apólice', 'Parcelas Pagas', 'Inadimplência', 'Comissão', 'Renovação', 'Pendência', 'Recusa', 'Sinistro'];
          break;
        case "Pós-venda":
          this.apis = ['Apólice', 'Endosso', 'Cartão segurado', 'Boleto'];
          break;
        default:
          this.apis = [];
      }
    },
    formatarValue(value) {
      let formattedValue = value;//.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      return formattedValue;
    },
    shouldShow(perg) {
      // Sem dependência => mostra
      if (perg == null || perg.dependenciaIndex == null) return true;

      const dependeDe = this.dadosFormulario.find(p => p.index === perg.dependenciaIndex);
      if (!dependeDe) return true; // se não achar, não bloqueia

      const resp = this.respostas[dependeDe.index];

      // Se usar respostaIndex (posição na lista de opções da dependência)
      if (typeof perg.respostaIndex === 'number' && Array.isArray(dependeDe.opcoes)) {
        const idx = dependeDe.opcoes.findIndex(o => o === resp);
        return idx === perg.respostaIndex;
      }

      // fallback: exibe se houver qualquer resposta na dependência
      return !!resp;
    },
    async consultarFormulario(id) {
      const urlApi = '/massificados/corporativo/gerenciador-parceiros/integracao/consultar-formulario/' + id;

      const resp = await ajaxUtils.get(urlApi);
      const raw = Array.isArray(resp) ? resp.slice()
                : (resp && Array.isArray(resp.perguntas) ? resp.perguntas.slice() : []);

      var seq = raw.map(function (p) {
      var tipoNorm = (p.tipo || '').toString().toUpperCase();
      tipoNorm = (tipoNorm === 'MULTIPLAESCOLHA') ? 'radio'
            : (tipoNorm === 'PERGUNTA') ? 'texto'
            : (p.tipo || 'texto');
      var dep = (typeof p.respostaIndex !== null) ? p.respostaIndex : p.respostaIndex;

      var ops = Array.isArray(p.opcoes) ? p.opcoes.slice()
        : (p.opcoes == null ? [] : String(p.opcoes).split(',').map(function(s){ return s.trim(); }).filter(function(s){ return s.length; }));

      // NOVO: calcula exibe/resposta no front
      var exibeInicial = (dep == null) ? 'S' : 'N';  // raiz mostra; dependente só após clique
      var respostaInicial = '';                      // texto vazio (radio também começa vazio)

      return {
        index: (typeof p.index === 'number') ? p.index : Number(p.index),
        tipo: tipoNorm,
        pergunta: p.pergunta || '',
        opcoes: ops,
        dependenciaIndex: (p.dependenciaIndex == null) ? null : Number(p.dependenciaIndex),
        respostaIndex: (p.respostaIndex == null) ? null : Number(p.respostaIndex),
        exibe: exibeInicial,               // <<< criado aqui
        resposta: respostaInicial          // <<< criado aqui
      };
      });

      seq.sort(function (a, b) { return a.index - b.index; });
      for (var i = 0; i < seq.length; i++) seq[i].index = i;

      this.dadosFormulario = seq;
      this.showPerguntas = true;
    },



    // FUNCTION(indexAux, respostaIndexAux, valor)
    atualizarResposta(indexAux, respostaIndexAux, valor) {
      var lista = this.dadosFormulario || [];
      for (var i = 0; i < lista.length; i++) {
        var p = lista[i];
        if (p.index === indexAux) {
          p.resposta = (valor == null) ? '' : String(valor);
        }
        if (p.dependenciaIndex === indexAux) {
          if (p.respostaIndex === respostaIndexAux) {
            p.exibe = 'S';
          } else {
            p.exibe = 'N';
            p.resposta = '';
          }
        }
      }
      this.dadosFormulario = lista.slice();
    },


    // 1º nível: dependenciaIndex == null E exibe == 'S'
    raizPerguntas() {
      return this.dadosFormulario.filter(function (p) {
        return p.dependenciaIndex === null && p.exibe === 'S';
      });
    },

    // Filhas do (parentIdx) para a opção 1-based (opcaoIdxOneBased)
    childrenFor(parentIdx, opcaoIdxOneBased) {
      return this.dadosFormulario.filter(function (p) {
        return p.dependenciaIndex === parentIdx && p.respostaIndex === opcaoIdxOneBased;
      });
    },

    async salvarFormulario() {
      const selectApi = $("#select-api").val();
      const selectCatalogo = $("#select-catalogo").val();
      const inputTerminoDesenvolvimento = $("#dateInput").val();
      let inputObservacao = $("#observacao").val();

      if (inputTerminoDesenvolvimento.length < 10) {
        alertUtils.alertError("Preencha o campo 'Término de Desenvolvimento' corretamente.");
        return false;
      }
      if (inputObservacao.length < 1) inputObservacao = "";

      // === validar() conforme sua regra ===
      var listaPerguntaReposta = [];
      for (var i = 0; i < this.dadosFormulario.length; i++) {
        var p = this.dadosFormulario[i];
        if (p.exibe === 'S' && (!p.resposta || p.resposta.trim() === '')) {
          alertUtils.alertError("Favor responder a pergunta: \"" + p.pergunta + "\"");
          return false;
        }
        if (p.exibe === 'S') {
          listaPerguntaReposta.push({
            pergunta: p.pergunta,
            resposta: p.resposta || ''
          });
        }
      }

      const bodyFormulario = {
        catalogo: selectCatalogo,
        api: selectApi,
        dataTerminoDesenvolvimento: inputTerminoDesenvolvimento.replace(/\//g, "-"),
        observacao: inputObservacao,
        listaPerguntaResposta: listaPerguntaReposta
      };

      const urlApi = '/massificados/corporativo/gerenciador-parceiros/integracao/salvar-integracao';
      const jsonRequest = JSON.stringify(bodyFormulario);

      const ok = await ajaxUtils.postOK(urlApi, jsonRequest, 'Salvo com sucesso!', '');
      if (ok === true) {
        document.querySelectorAll('.btn-primary').forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            location.reload();
          });
        });
        document.addEventListener('click', function (event) {
          var modal = document.querySelector('.swal2-icon-success');
          if (modal && !modal.contains(event.target)) location.reload();
        });
      }
    },
    slugify(txt) {
      return String(txt || '').toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-');
    }


  },
  computed: {
    visiveis() {
      // Inicial: só quem não tem pai (dependenciaIndex == null).
      // Dinâmica: qualquer pergunta (mesmo com pai) cujo exibe == 'S' também entra.
      return (this.dadosFormulario || []).filter(function (p) { return p.exibe === 'S'; });
    }
  },

  created() { },
  
  mounted() {
    const input = document.getElementById('dateInput');
    input.addEventListener('input', function (e) {
      let value = e.target.value.replace(/\D/g, ''); // Remove qualquer caractere não numérico
      if (value.length <= 2) {
        e.target.value = value.replace(/(\d{2})(\d{0,2})/, '$1/$2');
      } else if (value.length <= 4) {
        e.target.value = value.replace(/(\d{2})(\d{2})(\d{0,4})/, '$1/$2/$3');
      } else {
        e.target.value = value.replace(/(\d{2})(\d{2})(\d{4})(\d{0,0})/, '$1/$2/$3');
      }
    });
  },
}
</script>

<style scoped>
@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-api/css/style.css';
@import '/massificados/corporativo/gerenciador-parceiros-ui/suporte-portal-api/css/style.css';
</style>